/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
} from './CriteriaCategory';

/**
 * 
 * @export
 * @interface BulkUpdateCriteriaCategoriesRequest
 */
export interface BulkUpdateCriteriaCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateCriteriaCategoriesRequest
     */
    facility_id?: string;
    /**
     * 
     * @type {Array<CriteriaCategory>}
     * @memberof BulkUpdateCriteriaCategoriesRequest
     */
    categories: Array<CriteriaCategory>;
}

/**
 * Check if a given object implements the BulkUpdateCriteriaCategoriesRequest interface.
 */
export function instanceOfBulkUpdateCriteriaCategoriesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "categories" in value;

    return isInstance;
}

export function BulkUpdateCriteriaCategoriesRequestFromJSON(json: any): BulkUpdateCriteriaCategoriesRequest {
    return BulkUpdateCriteriaCategoriesRequestFromJSONTyped(json, false);
}

export function BulkUpdateCriteriaCategoriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateCriteriaCategoriesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'categories': ((json['categories'] as Array<any>).map(CriteriaCategoryFromJSON)),
    };
}

export function BulkUpdateCriteriaCategoriesRequestToJSON(value?: BulkUpdateCriteriaCategoriesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'categories': ((value.categories as Array<any>).map(CriteriaCategoryToJSON)),
    };
}

